export const passwordRegexp = /^[A-Za-z0-9~!@#$%^&*()_+|<>?:{}+]{7,13}$/;

export const onlyNumberRegexp = /^[0-9]*$/;
